import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgRename = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_397_32369",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_397_32369)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M1.6665 19.9999V17.4999H18.3332V19.9999H1.6665ZM4.99984 13.6778H6.03025L12.9469 6.77388L12.423 6.24201L11.9038 5.73076L4.99984 12.6474V13.6778ZM3.74984 14.9278V12.1153L13.0913 2.7868C13.212 2.6661 13.349 2.57478 13.5023 2.51284C13.6555 2.45089 13.815 2.41992 13.9807 2.41992C14.1465 2.41992 14.3071 2.45089 14.4623 2.51284C14.6176 2.57478 14.7599 2.67041 14.8892 2.79971L15.8909 3.81409C16.0202 3.93478 16.1137 4.07305 16.1713 4.22888C16.2289 4.38457 16.2578 4.54555 16.2578 4.7118C16.2578 4.86763 16.2285 5.02256 16.17 5.17659C16.1116 5.33076 16.0185 5.47166 15.8909 5.5993L6.56234 14.9278H3.74984ZM12.9469 6.77388L12.423 6.24201L11.9038 5.73076L12.9469 6.77388Z",
			fill: "currentColor"
		})
	})]
});
export default SvgRename;
